import React, { Fragment } from 'react'

import { MembershipQuery, getHTML } from '../../core'
import Page from '../../components/Page'


class LocationTemplate extends React.Component {
  render() {
    return (
      <MembershipQuery 
        slug={this.props.pageContext.slug}
        render={Page}
      />
    )
  }
}

export default LocationTemplate
